"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CategoryLink = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge"),
  defaultCategoryStyles = () => {
    return {
      display: "flex",
      lineHeight: "1.4",
      padding: "0"
    };
  },
  defaultCategoryListStyles = () => {
    return {
      alignItems: "center",
      display: "inline-flex",
      justifyContent: "center",
      padding: "0",
      width: "auto"
    };
  },
  defaultCategoryButtonStyles = theme => {
    return {
      borderRadius: "0",
      color: "inherit",
      font: "inherit",
      lineHeight: "1.2",
      padding: "1.1rem 2.4rem",
      textTransform: "none",
      position: "relative",
      "&:hover,&:active": {
        textDecoration: "underline"
      },
      "&:focus-visible": {
        outlineColor: "white"
      },
      "&.category__button--isSelected": {
        backgroundColor: theme.palette.primary.main,
        fontFamily: theme.fontFamilies.semiBold,
        "&::after": {
          borderColor: `${theme.palette.primary.main} transparent transparent transparent`,
          borderStyle: "solid",
          borderWidth: "1.1rem 2rem 0 2rem",
          content: "''",
          display: "block",
          height: "0",
          left: "50%",
          marginLeft: "-2rem",
          position: "absolute",
          top: "100%",
          width: "0"
        }
      }
    };
  },
  CategoryLink = props => {
    const {
        customCategoryListStyles = {},
        customCategoryButtonStyles = {},
        label,
        role,
        selected,
        testId,
        theme,
        ...rest
      } = props,
      buttonClass = (0, _classnames.default)({
        "category__button": true,
        "category__button--isSelected": selected
      }),
      categoryListStyles = merge(defaultCategoryListStyles(theme), customCategoryListStyles),
      categoryButtonStyles = merge(defaultCategoryButtonStyles(theme), customCategoryButtonStyles);
    return /*#__PURE__*/_react.default.createElement(_material.ListItem, {
      "data-testid": testId,
      role: role,
      sx: categoryListStyles
    }, /*#__PURE__*/_react.default.createElement(_material.Button, _extends({
      className: buttonClass
    }, rest, {
      sx: categoryButtonStyles,
      "data-testid": (0, _string.isStringOfLength)(testId) ? `${testId}_button` : undefined
    }), label));
  };

/**
 * Desktop Navigation Category Selector, used in Page Header Component
 *
 * @visibleName Desktop Navigation - Category Selector
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.CategoryLink = CategoryLink;
const Category = props => {
  const {
      bundledStyles = {},
      categoryArray,
      customTheme = {},
      onClick,
      selectedCategory,
      testId
    } = props,
    theme = merge((0, _styles.useTheme)(), customTheme),
    {
      customCategoryStyles = {},
      customCategoryListStyles = {},
      customCategoryButtonStyles = {}
    } = bundledStyles,
    categoryStyles = merge(defaultCategoryStyles(theme), customCategoryStyles);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, categoryArray.length > 1 && /*#__PURE__*/_react.default.createElement(_material.List, {
    "aria-label": "Site Category Selector",
    component: "ul",
    "data-testid": testId,
    role: "menu",
    sx: categoryStyles
  }, categoryArray.map((item, i) => /*#__PURE__*/_react.default.createElement(CategoryLink, {
    customCategoryListStyles: customCategoryListStyles,
    customCategoryButtonStyles: customCategoryButtonStyles,
    key: `category_${i}`,
    label: item.label,
    onClick: onClick,
    role: "menuitem",
    selected: item.value === selectedCategory,
    theme: theme,
    value: item.value
  }))));
};

// Define propTypes;
Category.propTypes = {
  /** Collection of custom styles objects (Default Value: {}) */
  bundledStyles: _propTypes.default.shape({
    /** Custom styles object for component */
    customCategoryStyles: _propTypes.default.object,
    /** Custom styles object for list of categories */
    customCategoryListStyles: _propTypes.default.object,
    /** Custom styles object for list item category button */
    customCategoryButtonStyles: _propTypes.default.object
  }),
  /** Array of category labels and values */
  categoryArray: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** Visible Label of Category */
    label: _propTypes.default.string.isRequired,
    /** Unique Internal Value used in state */
    value: _propTypes.default.string.isRequired
  })).isRequired,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Category Item Click Handler */
  onClick: _propTypes.default.func.isRequired,
  /** Selected Category Value for initial display */
  selectedCategory: _propTypes.default.string,
  /** @ignore */
  testId: _propTypes.default.string
};
CategoryLink.propTypes = {
  customCategoryListStyles: _propTypes.default.object,
  customCategoryButtonStyles: _propTypes.default.object,
  label: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired,
  selected: _propTypes.default.bool,
  testId: _propTypes.default.string,
  theme: _propTypes.default.object,
  value: _propTypes.default.string.isRequired
};

// Export component as default;
var _default = exports.default = Category;